import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { AdministratorService } from '../../../services/administrator.service';
import { gridPageRequest, userRolesList } from '../../../model/common/common.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TreeTableModule } from 'primeng/treetable';
import { MessageService, TreeNode } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, switchMap } from 'rxjs';
import { SharedServiceService } from '../../../services/shared-service.service';

@Component({
  selector: 'app-assign-role',
  standalone: true,
  imports: [SharedModule,TreeTableModule,CommonModule],
  templateUrl: './assign-role.component.html',
  styleUrl: './assign-role.component.scss'
})


export class AssignRoleComponent implements OnInit {

  roleList: any[] = [];
  files: TreeNode<any>[] = [];
  selectedMenu: TreeNode<any>[] | any = [];
  loader: boolean = false;
  submitted: boolean = false;
  RoleId: any;
  isEditMode: boolean = true;
  data: any[] = [];


  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  }


  assignRoleForm = new FormGroup({
    Role: new FormControl<userRolesList | null>(null , Validators.required),
    RoleId: new FormControl(),
    MenuId: new FormControl(),
    IsActive:new FormControl(),
    Description : new FormControl('', Validators.required),
    CreatedDate : new FormControl(),
    UpdatedDate : new FormControl(),
    createdBy: new FormControl(),
    SubMenusId : new FormControl(),
  });
  assignRole: any[] | undefined;

  constructor(private administratorService: AdministratorService, private messageService: MessageService, private route: Router, private activatedRoute: ActivatedRoute,   private sharedService: SharedServiceService,) { }

  ngOnInit(): void {
    document.title = 'Assign Role';
    this.getAllRoles();
    this.assignRoleForm.controls['createdBy'].setValue(sessionStorage.getItem('username'));
    this.assignRoleForm.controls.Description.disable();
    this.getMenuList();
    this.patchAssignRole();
  }

  getAllRoles(): void {
    this.administratorService.getAllRoles().subscribe({
      next: (data: any) => {
        this.roleList = data;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getMenuList(): void {
    this.administratorService.GetAllMenu().subscribe({
      next: (data: any) => {
        this.files = this.transformData(data);
      },
      error: error => {
        console.log(error);
      }
    });
  }


  transformData(originalData: any[]): TreeNode[] {
    return originalData.map(item => {
      const transformedItem: TreeNode = {
        data: {
          menu: item.name,
          menuid: item.menuId,
          submenuId: null,
          submenu: ''
        },
        children: item.subMenu ? this.transformSubmenu(item.subMenu, item.menuId) : undefined // Pass parent menuId to submenus
      };

      return transformedItem;
    });
  }

  transformSubmenu(originalData: any[], parentMenuId: number): TreeNode[] {
    return originalData.map(item => {
      const transformedItem: TreeNode = {
        data: {
          submenuId: item.menuId,
          submenu: item.name,
          menuid: parentMenuId
        }
      };

      return transformedItem;
    });
  }



  selectRole(event: any): void {
    if (event.value) {
      this.assignRoleForm.controls.Description.setValue(event.value.roleDescription);
      this.getRoleMenu(event.value.roleId);
    }


    let selectedSubMenuId = null;
    this.selectedMenu.forEach((node: TreeNode) => {
      if (node.data.submenuId) {
        selectedSubMenuId = node.data.submenuId;
      }
    });

  }


  save(): void {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    const roleData = this.assignRoleForm.value;
    const roleId = roleData.Role ? Number(roleData.Role.roleId) : null;

    if (roleId) {
      this.administratorService.getAllgetAssignRoleInfo(this.pageRequest).subscribe({
        next: (data: any) => {
          const roleExists = data.assignRole.some((role: any) => role.roleId === roleId);
          if (roleExists) {
            this.loader = false;
            this.messageService.add({ severity: 'error', summary: 'Role Already Assigned', detail: 'The selected role has already been assigned.' });
            return;
          }

          let selectedMenus: { menuId: any; submenuId: any; roleId: number | null; description: any; isActive: boolean; createdBy: any; createdDate: string; updatedDate: string; }[] = [];

          this.selectedMenu.forEach((node: TreeNode) => {
            if (node.data && node.data.menuid) {
              let selectedMenuId = node.data.menuid;

              const children = node.children || (node.parent && node.parent.children) || [];

              if (children.length > 0) {
                children.forEach((child: any) => {
                  if (child.data && child.data.submenuId && child.data.submenuId === node.data.submenuId) {
                    selectedMenus.push({
                      menuId: selectedMenuId,
                      submenuId: child.data.submenuId,
                      roleId: roleId,
                      description: this.assignRoleForm.controls.Description.value,
                      isActive: true,
                      createdBy: this.assignRoleForm.controls.createdBy.value,
                      createdDate: new Date().toISOString(),
                      updatedDate: new Date().toISOString(),
                    });
                  }
                });
              } else {
                selectedMenus.push({
                  menuId: selectedMenuId,
                  submenuId: null,
                  roleId: roleId,
                  description: this.assignRoleForm.controls.Description.value,
                  isActive: true,
                  createdBy: this.assignRoleForm.controls.createdBy.value,
                  createdDate: new Date().toISOString(),
                  updatedDate: new Date().toISOString(),
                });
              }
            }
          });

          if (selectedMenus.length === 0) {
            console.error('No valid menu and submenu selected.');
            return;
          }

          this.administratorService.createAssignRole(selectedMenus).subscribe({
            next: (response) => {
              this.loader = true;
              this.messageService.add({ severity: 'success', summary: 'Role assigned successfully', detail: response.message });
              setTimeout(() => {
                this.route.navigate(['/home/listassignroles']);
              }, 1000);
            },
            error: (error) => {
              this.loader = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while saving role assignments. Please try again later.' });
            }
          });
        },
        error: (error) => {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching role information. Please try again later.' });
        }
      });
    } else {
      console.error('Invalid roleId.');
    }
  }

  update(data: any) {
    if (this.assignRoleForm.invalid) {
      return;
    }

    const roleData = this.assignRoleForm.value;
    const roleId = roleData.Role ? Number(roleData.Role.roleId) : null;

    let selectedMenus: { menuId: any; submenuId: any; roleId: number | null; description: any; isActive: boolean; createdBy: any; createdDate: string; updatedDate: string; }[] = [];

    this.selectedMenu.forEach((node: TreeNode) => {
      if (node.data && node.data.menuid) {
        const selectedMenuId = Number(node.data.menuid);
        const children = node.children || (node.parent && node.parent.children) || [];

        if (children.length > 0) {
          children.forEach((child: any) => {
            if (child.data && child.data.submenuId && child.data.submenuId === node.data.submenuId) {
              selectedMenus.push({
                menuId: selectedMenuId,
                submenuId: child.data.submenuId ? Number(child.data.submenuId) : null,
                roleId: roleId,
                description: this.assignRoleForm.controls.Description.value,
                isActive: true,
                createdBy: this.assignRoleForm.controls.createdBy.value,
                createdDate: new Date().toISOString(),
                updatedDate: new Date().toISOString(),
              });
            }
          });
        } else {
          selectedMenus.push({
            menuId: selectedMenuId,
            submenuId: node.data.submenuId ? Number(node.data.submenuId) : null,
            roleId: roleId,
            description: this.assignRoleForm.controls.Description.value,
            isActive: true,
            createdBy: this.assignRoleForm.controls.createdBy.value,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString(),
          });
        }
      }
    });

    let inactiveMenus = this.data.filter((item: any) => {
      return !selectedMenus.some((menu: any) =>
        menu.menuId === item.menuId && menu.submenuId === item.subMenuId
      );
    })

    this.loader = true;
    forkJoin([
      this.administratorService.updateAssignRole(selectedMenus),
      this.administratorService.inActiveuAssignRole(inactiveMenus)
    ]).subscribe({
      next: () => {
        this.loader = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Assign Role Updated Successfully.' });
        this.sharedService.triggerMenuRefresh();

        setTimeout(() => {
          this.route.navigate(['/home/listassignroles']);
        }, 1000);
      },
      error: (error) => {
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while updating the role assignment. Please try again later.' });
      }
    });
  }

  patchAssignRole(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      setTimeout(() => {
        this.RoleId = params['RoleId'];
        this.isEditMode = !!this.RoleId;

        if (this.isEditMode) {
          this.administratorService.getAssignRoleById(this.RoleId).subscribe({
            next: (data: any) => {
              console.log(data);
              this.data = data;
              if (data && data.length > 0) {
                const selectedRole = this.roleList.find(role => role.roleDescription === data[0].description);
                this.assignRoleForm.patchValue({
                  Role: selectedRole,
                  Description: data[0].description,
                  CreatedDate: data[0].createdDate,
                  createdBy: data[0].createdBy,
                });
                if (Array.isArray(data.assignRoleId)) {
                  this.assignRole = [...data.assignRoleId];
                } else {
                  this.assignRole = [data.assignRoleId];
                } const selectedMenuIds = data.flatMap((item: { menuId: any; }) =>
                  Array.isArray(item.menuId) ? item.menuId : [item.menuId]
                );
                const selectedSubMenuIds = data.flatMap((item: { subMenuId: any; }) =>
                  Array.isArray(item.subMenuId) ? item.subMenuId : [item.subMenuId]
                );

                this.selectedMenu = [];

                this.files.forEach((node: TreeNode) => {
                  if (selectedMenuIds.includes(node.data.menuid)) {
                    this.selectedMenu.push(node);

                    if (node.children) {
                      node.children.forEach((child: TreeNode) => {
                        if (selectedSubMenuIds.includes(child.data.submenuId)) {
                          this.selectedMenu.push(child);
                        }
                      });
                    }
                  }
                });
              }
            },
            error: (error: any) => {
              console.error('Error fetching Assign Role data:', error);
            }
          });
        }
      }, 100);
    });
  }


  validateForm() {
    let isValid = true;
    if (this.assignRoleForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }
    return isValid;
  }

  getRoleMenu(roleId: string): void {
    this.administratorService.getRoleMenu(roleId).pipe(
      switchMap((data: any) => {
        this.files = this.transformData(data);
        return this.administratorService.getAssignRoleById(roleId);
      })
    ).subscribe({
      next: (assignRoleData: any) => {
        console.log(assignRoleData);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  get formControls() {
    return this.assignRoleForm.controls;
  }
  reset(): void {
    this.assignRoleForm.reset();
  }

  cancel(): void {
    this.route.navigate(['/home/listassignroles']);
  }


}
